// Version-scoped keys for the category / skill catalogues.
//
// A category or skill `code` is unique only WITHIN a versionCode — it is NOT a
// global identifier. The MEB catalogue deliberately reuses the same code across
// curriculum generations: `SB.5.1.` is BİREY VE TOPLUM in MEB-IO-SOS-2018
// (id 4376) *and* BİRLİKTE YAŞAMAK in MEB-IO-SOS-2024 (id 7366). 100 codes
// collide inside a single Sosyal Bilgiler profile's category list alone, because
// a profile loads every versionCode its coterie offers.
//
// Any map keyed by `code` alone therefore silently collapses two curricula into
// whichever row happens to win (first or last, depending on the loop), and any
// parentCode walk can cross from one generation into the other — which made the
// grade-5 Sosyal tree render every unit twice while dropping the 2024 units, and
// let outcome cards label a 2024 outcome with its retired 2018 unit name. Key by
// these helpers instead, and resolve a parentCode within the child's OWN
// versionCode.
//
// Safe by construction: no row in any shipped catalogue (MEB / IB / AP,
// categories or skills) has a parent that lives only under a different
// versionCode, so the scoping never orphans a legitimate link. Rows without a
// versionCode degrade to code-only behaviour rather than dropping out.
//
// Kept dependency-free so leaf utilities can import it without riding a module
// cycle through the library barrel.

export const buildCategoryVersionScopedKey = (
  versionCode: any,
  code: any,
): string => `${versionCode ?? ""}|${code ?? ""}`;

export const buildCategoryKey = (category: any): string =>
  buildCategoryVersionScopedKey(category?.versionCode, category?.code);

export const buildCategoryParentKey = (category: any): string =>
  buildCategoryVersionScopedKey(category?.versionCode, category?.parentCode);
